// This is to prevent terser from removing the check for the analytics flag: https://stackoverflow.com/questions/61318185/how-to-disable-dead-code-elimination-for-specific-blocks-or-files-in-webpack
// Since webpack runs before the variable substitution does, terser was removing this code since '_#_IncludeAnalytics_#_' === 'Include' is always false.
// Running "webpack --mode development" would still include the if statement, but "webpack --mode production" was removing it.
// By including a function to check the value, and adding /*#__NOINLINE__*/ to the if statement, this should be kept by webpack/terser
const analyticsNeeded = (analytics: string | undefined) => (analytics === 'Include')

if (/*#__NOINLINE__*/analyticsNeeded(process.env.INCLUDE_ANALYTICS)) {
    const analytics: HTMLScriptElement = document.createElement('script');
    analytics.async = true;
    analytics.src = "https://assets.adobedtm.com/c318d2739692/96e37aff7009/launch-4ef36d3c8aed.min.js"
    document.head.appendChild(analytics);
} else {
    const analytics: HTMLMetaElement = document.createElement('meta');
    analytics.name = "adobe-script"
    analytics.content = "not loaded"
    document.head.appendChild(analytics);
}